<script setup lang="ts">
import { computed } from "vue";

import SVGWrapper from "./utils/SVGWrapper.vue";

import type { colorTag } from "@/Modules/App/Models/Styles/Colors";
import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

export interface IconProps {
  size?: iconSize;
  color?: colorTag;
  background?: colorTag;
}

const props = withDefaults(defineProps<IconProps>(), { color: "content-high", size: "md" });

const colorClass = computed((): string => `fill-${props.color}`);
</script>

<template>
  <SVGWrapper :size="size" :background="background" viewBox="0 0 21 20">
    <path
      d="M19.0131 0H2.54254C1.56607 0 0.777832 0.783626 0.777832 1.75439V13.4503C0.777832 14.4211 1.56607 15.2047 2.54254 15.2047H3.13077V20L8.64842 15.2047H19.0131C19.9896 15.2047 20.7778 14.4211 20.7778 13.4503V1.75439C20.7778 0.783626 19.9896 0 19.0131 0ZM19.6014 13.4503C19.6014 13.7661 19.3425 14.0351 19.0131 14.0351H8.20136L4.30724 17.4269V14.0351H2.54254C2.21313 14.0351 1.9543 13.7661 1.9543 13.4503V1.75439C1.9543 1.4386 2.21313 1.16959 2.54254 1.16959H19.0131C19.3425 1.16959 19.6014 1.4386 19.6014 1.75439V13.4503Z"
      :class="colorClass"
    />
    <path
      d="M14.8954 11.5789C14.8954 11.8245 14.6954 12.0351 14.4366 12.0351C14.1778 12.0351 13.9778 11.8362 13.9778 11.5789C13.9778 9.82453 12.5425 8.39763 10.7778 8.39763C9.0131 8.39763 7.5778 9.82453 7.5778 11.5789C7.5778 11.8245 7.3778 12.0351 7.11898 12.0351C6.86016 12.0351 6.66016 11.8362 6.66016 11.5789C6.66016 9.32161 8.50722 7.48535 10.7778 7.48535C13.0484 7.48535 14.8954 9.32161 14.8954 11.5789Z"
      :class="colorClass"
    />
    <path
      d="M8.03654 5.67271C8.54335 5.67271 8.95419 5.26426 8.95419 4.76043C8.95419 4.25659 8.54335 3.84814 8.03654 3.84814C7.52974 3.84814 7.1189 4.25659 7.1189 4.76043C7.1189 5.26426 7.52974 5.67271 8.03654 5.67271Z"
      :class="colorClass"
    />
    <path
      d="M13.519 5.67271C14.0258 5.67271 14.4366 5.26426 14.4366 4.76043C14.4366 4.25659 14.0258 3.84814 13.519 3.84814C13.0122 3.84814 12.6013 4.25659 12.6013 4.76043C12.6013 5.26426 13.0122 5.67271 13.519 5.67271Z"
      :class="colorClass"
    />
  </SVGWrapper>
</template>

<style scoped lang="scss"></style>
